import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { AppConfigService } from './app/core/services/app-config-service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

async function main() {
  const appConfigService = new AppConfigService();
  await appConfigService.loadAppConfig();

  await bootstrapApplication(AppComponent, {
    providers: [
      ...appConfig.providers,
      provideHttpClient(withInterceptorsFromDi()),
      { provide: AppConfigService, useValue: appConfigService }
    ]
  });
}

main().catch(err => console.error(err));